import { render, staticRenderFns } from "./PlateToVin.vue?vue&type=template&id=4634ec26&scoped=true&"
import script from "./PlateToVin.vue?vue&type=script&lang=js&"
export * from "./PlateToVin.vue?vue&type=script&lang=js&"
import style0 from "./PlateToVin.vue?vue&type=style&index=0&id=4634ec26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4634ec26",
  null
  
)

export default component.exports